<template lang="pug">
  ods-dropdown(:hide-on-click='false'
  icon='setting'
  @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-documentacion',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      // Columnas Tabla Auditoria de documentos
      'isShowServicioDocumentacion',
      'isShowCategoriaDocumentacion',
      'isShowIdiomaDocumentacion',
      'isShowNombreDocumentacion',
      'optionsFilterService'
    ])
  },

  methods: {
    ...mapActions([
      // Columnas Tabla Auditoria de documentos
      'isShowServicioDocumentacionAction',
      'isShowCategoriaDocumentacionAction',
      'isShowIdiomaDocumentacionAction',
      'isShowNombreDocumentacionAction'
    ]),

    handlerShowColumns (col) {
      const column = col.value
      let isShow
      switch (column) {
        case 'servicio':
          isShow = !this.isShowServicioDocumentacion
          this.isShowServicioDocumentacionAction(isShow)
          break
        case 'categoria':
          isShow = !this.isShowCategoriaDocumentacion
          this.isShowCategoriaDocumentacionAction(isShow)
          break
        case 'idioma':
          isShow = !this.isShowIdiomaDocumentacion
          this.isShowIdiomaDocumentacionAction(isShow)
          break
        case 'nombre':
          isShow = !this.isShowNombreDocumentacion
          this.isShowNombreDocumentacionAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('documentation.documentation_entity_table.project'), value: 'servicio', show: this.isShowServicioDocumentacion
        }, {
          text: this.$t('documentation.documentation_entity_table.name'), value: 'nombre', show: this.isShowNombreDocumentacion
        }, {
          text: this.$t('documentation.documentation_entity_table.category'), value: 'categoria', show: this.isShowCategoriaDocumentacion
        }, {
          text: this.$t('documentation.documentation_entity_table.language'), value: 'idioma', show: this.isShowIdiomaDocumentacion
        }
      ]
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            this.columns.splice(index, 1)
          }
        }
        this.isShowServicioDocumentacionAction(false)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
